export const getInUsd = (value: number) => `$${value}`;
